import { mapGetters } from "vuex";

export default {
  methods: {
    isDynamic(property) {
      return typeof property === "function";
    },
    getLabelValue(property) {
      if (typeof property === "function") {
        return property(this.statementData, this.$route.params.statementUuid);
      } else {
        return property;
      }
    },
    getRequiredValue(property) {
      if (typeof property === "function") {
        return property(this.statementData,this.$route.params.statementUuid, this.isPartOfPilotProgramme);
      } else {
        return property;
      }
    },
    getVisibilityValue(property) {
      if (typeof property === "function") {
        return !property(this.statementData, this.$route.params.statementUuid, this.isPartOfPilotProgramme);
      } else {
        return false;
      }
    },
    getDisabledValue(property){
      if (typeof property === "function") {
        return property(this.statementData, this.$route.params.statementUuid, this.isPartOfPilotProgramme);
      } else {
        return !!property;
      }
    }
  },
  computed: {
    ...mapGetters(["getStatmentByUuid", "getFormData", "getRefData", "getService"]),
    statementData() {
      return this.getStatmentByUuid(this.$route.params.statementUuid) || this.getFormData;
    },
    isPartOfPilotProgramme(){
      // this checks whether current service is part of DOE pilot programme
      return !!this.getRefData.championServices.pi.find(service => service.seNumber === this.getService.seNumber);
    }
  }
};
